module.exports = __webpack_public_path__ + "img/CARACTE2.9d9e9eb9.jpg";